/* RESPONSIBLE TEAM: team-data-foundations */

export interface LineItemReason {
  lineItemId: number;
  reason: string;
}

export function buildPerItemNote(
  selectedItems: Array<{ lineItemId: number; quantity: number }>,
  lineItemReasons: LineItemReason[],
  orderLineItems: Array<{ id: number; title: string }>,
  options?: { shippingReason?: string; shippingLabel?: string },
): string {
  let itemsWithReasons = selectedItems
    .filter((sel) => sel.quantity > 0)
    .map((sel) => {
      let lineItem = orderLineItems.find((li) => li.id === sel.lineItemId);
      let reason = lineItemReasons.find((r) => r.lineItemId === sel.lineItemId);
      if (!reason?.reason) {
        return '';
      }
      return `${lineItem?.title} (x${sel.quantity}): ${reason.reason}`;
    })
    .filter((item) => item !== '');

  let noteContent = itemsWithReasons.join(' | ');

  if (options?.shippingReason && options?.shippingLabel) {
    let shippingPart = `${options.shippingLabel}: ${options.shippingReason}`;
    noteContent = noteContent ? `${noteContent} | ${shippingPart}` : shippingPart;
  }

  return noteContent.trim();
}

export function hasAllItemReasons(
  selectedItems: Array<{ lineItemId: number; quantity: number }>,
  lineItemReasons: LineItemReason[],
): boolean {
  let refundingItems = selectedItems.filter((sel) => sel.quantity > 0);
  return refundingItems.every((sel) =>
    lineItemReasons.some((r) => r.lineItemId === sel.lineItemId && r.reason),
  );
}
